import { createClient } from '@supabase/supabase-js';
import { logger } from '../logger';

// Vérifier les variables d'environnement
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

// Créer le client Supabase
export const supabaseClient = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'x-application-name': 'hotel-app'
    }
  }
});

// Log l'initialisation
logger.debug('Supabase client initialized', {
  category: 'Initialization',
  data: { url: supabaseUrl }
});